import React from 'react'
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom'
import ForgetPassword from '../Auth/forget-password/ForgetPassword'
import Login from '../Auth/login/Login'
import Logout from '../Dashboard/Logout'
import RegisterAdmin from '../Auth/register-admin/RegisterAdmin'
import Account from '../Dashboard/pages/account/Account'
import Dashboard from '../Dashboard/pages/dashboard/Dashboard'
import Company from '../Home/pages/company/Company'
import ContactUs from '../Home/pages/contact-us/ContactUs'
import Home from '../Home/pages/home/Home'
import Exhibition from '../exhibition/Exhibition'
import DashboardCategories from '../Dashboard/pages/dahboardCategories/DashboardCategories'
import DashboardSaloons from '../Dashboard/pages/dashboardSaloons/DashboardSaloons'
import DashboardSaloon from '../Dashboard/pages/dashboardSaloon/DashboardSaloon'
import DashboardUsersManagement from '../Dashboard/pages/dashboardUsersManagement/DashboardUsersManagement'
import DeveloperCompaniesManagement from '../Dashboard/pages/dashboardCompaniesManagement/DeveloperCompaniesManagement'
import AdminCompaniesManagement from '../Dashboard/pages/dashboardCompaniesManagement/AdminCompaniesManagement'
import NotFound from "../errors/NotFound";
import Saloons from '../Home/pages/halls/Saloons'
import DashboardSiteManagement from '../Dashboard/pages/dashboardSiteManagement/DashboardSiteManagement'
import Saloon from '../Home/pages/saloon/Saloon'
import News from '../Home/pages/news/News'
import Privacy from '../Home/pages/privacy/Privacy'
import Ethics from '../Home/pages/ethics/Ethics'
import ScrollToTop from './ScrollToTop'
import Messages from '../Dashboard/pages/messages/Messages'
import DashboardProduct from '../Dashboard/pages/dashboardProduct/DashboardProduct'
import DashboardSingleProduct from '../Dashboard/pages/dashboardProduct/DashboardSingleProduct'
import CompanyId from '../Home/pages/company/CompanyId'
import Product from '../Home/pages/product/Product'
import DashboardCompanyReview from '../Dashboard/pages/dashboardCompanyReview/DashboardCompanyReview'
import SingleNews from '../Home/pages/news/SingleNews'
import Announcements from '../Home/pages/announcements/Announcements'
import SingleAnnouncement from '../Home/pages/announcements/SingleAnnouncement'
import DashboardCompanyManagement from '../Dashboard/pages/dashboardCompanyManagement/DashboardCompanyManagement'
import Companies from '../Home/pages/companies/Companies'
import ManagerMessages from '../Dashboard/pages/managerMessages/ManagerMessages'
import CompanyManagerMessages from '../Dashboard/pages/managerMessages/CompanyManagerMessages'
import AdminTicketsView from '../Dashboard/pages/dashboardTickets/adminTickets/AdminTicketsView'
import UserTickets from '../Dashboard/pages/dashboardTickets/companyTickets/UserTickets'
import DashboardExpo from '../Dashboard/pages/dashboardExpo/DashboardExpo'
import SaloonExhibition from '../exhibition/SaloonExhibition'
import ExhibitionId from '../exhibition/ExhibitionId'

const Routes = () => {
    return (
        <>
        <Router>
            <ScrollToTop>
                <Switch>
                    <Route path="/exhibition/:id" component={ExhibitionId} />
                    <Route path="/exhibition" component={Exhibition} />
                    <Route path="/saloon-exhibition/:id" component={SaloonExhibition} />

                    <Route path="/login" component={Login} />
                    <Route path="/logout" component={Logout} />
                    <Route path="/register" component={RegisterAdmin} />
                    <Route path="/forget-password" component={ForgetPassword} />

                    <Route path="/dashboard/category-products/:id" component={DashboardProduct} />
                    <Route path="/dashboard/product/:id" component={DashboardSingleProduct} />

                    <Route path="/dashboard/saloon/:id" component={DashboardSaloon} />
                    <Route path="/dashboard/saloons" component={DashboardSaloons} />
                    <Route path="/dashboard/messages" component={Messages} />
                    <Route path="/dashboard/manager-messages" component={ManagerMessages} />
                    <Route path="/dashboard/company-manager-messages" component={CompanyManagerMessages} />
                    <Route path="/dashboard/send-ticket" component={UserTickets} />
                    <Route path="/dashboard/admin-tickets" component={AdminTicketsView} />

                    <Route path="/dashboard/categories" component={DashboardCategories} />
                    <Route path="/dashboard/account" component={Account} />
                    <Route path="/dashboard/site-management" component={DashboardSiteManagement} />
                    <Route path="/dashboard/users-management" component={DashboardUsersManagement} />
                    <Route path="/dashboard/developer-companies-management" component={DeveloperCompaniesManagement} />
                    <Route path="/dashboard/admin-companies-management" component={AdminCompaniesManagement} />
                    <Route path="/dashboard/companies-reviews-management" component={DashboardCompanyReview} />
                    <Route path="/dashboard/company-management" component={DashboardCompanyManagement} />
                    <Route path="/dashboard/expo" component={DashboardExpo} />

                    <Route path="/dashboard" exact component={Dashboard} />

                    <Route path="/saloon/:id" exact component={Saloon} />
                    <Route path="/saloons"  component={Saloons} />
                    <Route path="/companies" component={Companies} />
                    <Route path="/company/:id" component={CompanyId} />

                    <Route path="/product/:id" component={Product} />

                    <Route path="/contact-us" component={ContactUs} />
                    <Route path="/news/:id" component={SingleNews} />
                    <Route path="/news" component={News} />
                    <Route path="/announcement/:id" component={SingleAnnouncement} />
                    <Route path="/announcements" component={Announcements} />

                    <Route path="/privacy" component={Privacy} />
                    <Route path="/ethics" component={Ethics} />

                    <Route path="/404" component={NotFound} />
                    <Route path="/:username" component={Company} />

                    <Route path="/" exact component={Home} />
                    <Redirect to="/404" />
                </Switch>
            </ScrollToTop>
        </Router> 
        </>
    )
}

export default Routes
